import styled from 'styled-components';

export const Main = styled.main`
  height: 100%;
  width: 100%;
  background: #fff;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 80px;
`;

export const ExpansionHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;
